export enum ShipmentListFiltersServiceCode {
  BCO = 'BCO',
  FCL = 'FCL',
  FTL = 'FTL',
  HUB = 'HUB',
  HUBSHUTTLE = 'HUBSHUTTLE',
  LCL = 'LCL',
  LTL = 'LTL',
  MILKRUN = 'MILKRUN',
  Unknown = 'UNKNOWN',
}
